module.exports = __webpack_public_path__ + "static/media/dog-9.09ff3e18.jpg";